/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'SETTLED_DIRECTLY_BETWEEN_THE_WORKER_AND_THEIR_IMMEDIATE_SUPERVI',
              'SETTLED_WITH_THE_ASSISTANCE_OF_ADDITIONAL_STAKEHOLDERS_DEPARTME',
              'THERE_ARE_OPTIONS_FOR_SENIOR_MANAGEMENT_REVIEW_IF_DIRECT_SETTLE',
              'WORKERS_HAVE_THE_RIGHT_TO_RESPOND_TO_AND_OR_APPEAL_THE_SETTLEME',
              'NONE_OF_THE_ABOVE',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    how_are_complaints_and_grievances_settled_select_all_that_apply: valueSchema,
  },
}
